import emptyAuthState from 'features/auth/ducks/state'
import {
  clearAuthUserRoutine,
  fetchAuthUserRoutine,
  getAccreditationTypesRoutine,
  getInvitationRoutine,
  loginUserRoutine,
  logoutUserRoutine,
  registerUserRoutine,
  updateUserRoutine,
  updateUserLocalRoutine,
  clearLatestInvitationRoutine,
  getPublicApiTokenRoutine,
  clearPublicApiTokenRoutine,
  setTwoFactorChallengeRoutine,
  verifyTwoFactorLoginRoutine,
  getTwoFactorStatusRoutine,
  startTwoFactorSetupRoutine,
  confirmTwoFactorSetupRoutine,
  disableTwoFactorRoutine,
  regenerateTwoFactorRecoveryCodesRoutine
} from 'features/auth/ducks/actions'
import { getUnitInvitationRoutine } from 'ducks/units/actions'

export default (state = emptyAuthState, action) => {
  switch (action.type) {
    case loginUserRoutine.REQUEST:
    case registerUserRoutine.REQUEST:
    case fetchAuthUserRoutine.REQUEST:
    case logoutUserRoutine.REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case registerUserRoutine.SUCCESS:
    case loginUserRoutine.SUCCESS:
    case fetchAuthUserRoutine.SUCCESS:
      return {
        ...state,
        user: action.payload,
        isLoading: false
      }
    case updateUserRoutine.SUCCESS:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
        isLoading: false
      }
    case updateUserLocalRoutine.TRIGGER:
      return {
        ...state,
        user: { ...state.user, ...action.payload }
      }
    case logoutUserRoutine.SUCCESS:
    case clearAuthUserRoutine.SUCCESS:
      return {
        ...state,
        user: {},
        twoFactorChallenge: null,
        isLoading: false
      }
    case registerUserRoutine.FAILURE:
    case loginUserRoutine.FAILURE:
    case fetchAuthUserRoutine.FAILURE:
    case logoutUserRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      }
    case getAccreditationTypesRoutine.SUCCESS:
      return {
        ...state,
        accreditations: action.payload
      }
    case getInvitationRoutine.SUCCESS:
    case getUnitInvitationRoutine.SUCCESS:
      return {
        ...state,
        currentInvitation: action.payload
      }
    case clearLatestInvitationRoutine.SUCCESS: {
      return {
        ...state,
        currentInvitation: {}
      }
    }
    case getPublicApiTokenRoutine.SUCCESS: {
      return {
        ...state,
        publicApiToken: action.payload
      }
    }
    case clearPublicApiTokenRoutine.SUCCESS: {
      return {
        ...state,
        publicApiToken: null
      }
    }
    case setTwoFactorChallengeRoutine.SUCCESS:
      return {
        ...state,
        twoFactorChallenge: action.payload,
        isLoading: false
      }
    case verifyTwoFactorLoginRoutine.REQUEST:
    case getTwoFactorStatusRoutine.REQUEST:
    case startTwoFactorSetupRoutine.REQUEST:
    case confirmTwoFactorSetupRoutine.REQUEST:
    case disableTwoFactorRoutine.REQUEST:
    case regenerateTwoFactorRecoveryCodesRoutine.REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case verifyTwoFactorLoginRoutine.SUCCESS:
      return {
        ...state,
        user: action.payload,
        twoFactorChallenge: null,
        isLoading: false
      }
    case getTwoFactorStatusRoutine.SUCCESS:
    case confirmTwoFactorSetupRoutine.SUCCESS:
    case disableTwoFactorRoutine.SUCCESS:
    case regenerateTwoFactorRecoveryCodesRoutine.SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          twoFactorEnabled: action.payload.enabled
        },
        twoFactorStatus: action.payload,
        isLoading: false
      }
    case startTwoFactorSetupRoutine.SUCCESS:
      return {
        ...state,
        twoFactorSetup: action.payload,
        twoFactorStatus: action.payload,
        isLoading: false
      }
    case verifyTwoFactorLoginRoutine.FAILURE:
    case getTwoFactorStatusRoutine.FAILURE:
    case startTwoFactorSetupRoutine.FAILURE:
    case confirmTwoFactorSetupRoutine.FAILURE:
    case disableTwoFactorRoutine.FAILURE:
    case regenerateTwoFactorRecoveryCodesRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
